import { v4 as uuid } from 'uuid'

// Projects images imports
import img_project_keepitorganized from "../assets/img_project/keepitorganized.png"
import vid_project_keepitorganized from "../assets/img_project/showcases/showcase_keepitorganized.mp4"
import img_project_arenafighttv from "../assets/img_project/arenafighttv.png"
import vid_project_arenafighttv from "../assets/img_project/showcases/showcase_arenafighttv.mp4"
import img_project_moi_v3 from "../assets/img_project/mbf_v3.png"
import img_project_moi_v2 from "../assets/img_project/vitrine_moi_v2.png"
import img_project_moi_v1 from "../assets/img_project/vitrine_moi_v1.png"
import img_project_videozz from "../assets/img_project/videozz.png"
import vid_project_videozz from "../assets/img_project/showcases/showcase_videozz.mp4"
import img_livics from "../assets/img_project/livics.png"
import img_project_rent4aWeek from "../assets/img_project/rent4aWeek.png"
import vid_project_rent4aWeek from "../assets/img_project/showcases/showcase_rentforaweek.mp4"
import img_siteVitrineAntoinePavy from "../assets/img_project/siteVitrine_antoinePavy.png"
import img_foodtruckOnline from "../assets/img_project/foodtruckOnline.jpg"
import img_autowriteJs from "../assets/img_project/autowrite_js.png"
import img_3wcode from "../assets/img_project/3w_code.png"
import img_paretoConstats from "../assets/img_project/pareto_constats.png"
import img_providus from "../assets/img_project/providus.png"
import img_bookey from "../assets/img_project/bookey.png"
import img_devJobLister from "../assets/img_project/devJobLister.jpg"
import img_leafletMap from "../assets/img_project/leafletMap.png"

// Icons import
import { FaDatabase, FaLaptopCode, FaPencilAlt } from "react-icons/fa"
import { MdPhoneIphone } from "react-icons/md"
import { RiComputerLine } from "react-icons/ri"
import { BsGraphUp } from "react-icons/bs"

/* PRESTATIONS _____________________________________________________________________________  */
export const prestations = [
  {
    title: "Site vitrine",
    Icon: RiComputerLine,
    text: "Présentez votre projet d'entreprise et attirez de nouveaux clients avec un site web à votre image qui permettra à vos clients de mieux vous connaître. Donnons ensemble une voix à votre projet."
  },
  {
    title: "Intégration de maquettes",
    Icon: FaLaptopCode,
    text: "Vous possédez déjà la maquette de votre site parfait ? Il ne nous reste plus qu'à la transformer en projet réel déployé en ligne, à la vue de tout vos clients et accessible sur tout les moteurs de recherches."
  },
  {
    title: "Refonte graphique",
    Icon: FaPencilAlt,
    text: "Vous possédez déjà un site web mais vous souhaiteriez le remettre au goût du jour ? Je vous aide à créer un site web qui colle à votre image, avec un design intuitif et adapté pour une expérience utilisateur optimale."
  },
  {
    title: "Développement moderne",
    Icon: FaDatabase,
    text: "Faisons de votre site web une plateforme performante, moderne et maintenable dans le temps avec des technologies actuelles et efficaces. Votre site d'aujourd'hui, mais aussi de demain."
  },
  {
    title: "Responsive design",
    Icon: MdPhoneIphone,
    text: "Créons une plateforme adaptée à tout les appareils de vos clients. Qu'ils visitent votre site web sur un smartphone, une tablette ou encore un ordinateur, acceuillons les avec le design adapté."
  },
  {
    title: "Référencement SEO",
    Icon: BsGraphUp,
    text: "Vous avez un site web designé et deployé en ligne, super ! Il ne reste plus qu'à l'optimiser pour le référencement sur les moteurs de recherches. Trouvons ensemble le positionnement à adopter pour vous faire remarquer sur le web :)"
  }
]

/* FAVORITE BOOKS __________________________________________________________________________  */
export const favBooks = [
  {
    title: "Tout le monde n'a pas eu la chance de rater ses études",
    author: "Olivier Roland",
    coverImg: "https://images-na.ssl-images-amazon.com/images/I/61nYdjoDk2L.jpg",
    link: "https://amzn.to/3niRCvi",
    text: ``
  },
  {
    title: "La semaine de 4 heures",
    author: "Timothy Ferriss",
    coverImg: "https://images-eu.ssl-images-amazon.com/images/I/51tRKb4SqFL._SX342_QL70_ML2_.jpg",
    link: "https://amzn.to/3jwt9k3",
    text: ``
  },
  {
    title: "Comment parler à tout le monde",
    author: "Leil Lowndes",
    coverImg: "https://images-na.ssl-images-amazon.com/images/I/51SVsQin6SL.jpg",
    link: "https://amzn.to/33ulsp1",
    text: ``
  },
  {
    title: "Side Hustle",
    author: "Chris Guillebeau",
    coverImg: "https://m.media-amazon.com/images/I/51Qy5-Nse5L.jpg",
    link: "https://amzn.to/2So22vB",
    text: ``
  },
  {
    title: "Réfléchissez et devenez riche",
    author: "Napoleon Hill",
    coverImg: "https://e-leclerc.scene7.com/is/image/gtinternet/Electre_978-2-290-02882-7_9782290028827?op_sharpen=1&resmode=bilin&wid=600&hei=600",
    link: "https://amzn.to/3ldJLNK",
    text: ``
  },
  {
    title: "Père riche Père pauvre",
    author: "Robert Kiyosaki",
    coverImg: "https://images-na.ssl-images-amazon.com/images/I/716f1Rtx1CL.jpg",
    link: "https://amzn.to/33rGYKX",
    text: ``
  },
]

/* PROJECTS ________________________________________________________________________________  */
export const projects = [
  {
    id: uuid(),
    name: "Keep It Organized",
    description: `
      Outils Saas en développement ayant pour objectif d'accompagner les entrepreneurs digitaux ainsi que les social medias managers dans l'organisation de leurs publications sur ces réseaux.
    `,
    img: img_project_keepitorganized,
    showcase: vid_project_keepitorganized,
    tags: ["React.js", "React Context", "Firebase Cloud", "Material-ui", "JAMstack"],
    date: ["Décembre 2020", "Maintenant"],
    link: "https://keepitorganized.netlify.app",
    github: ""
  },
  {
    id: uuid(),
    name: "ArenaFightTV",
    description: `
      Plateforme streaming vidéo premium de combat développé from scratch avec 1 autre développeur
      web. Création espace utilisateurs avec espace admin, analytics, player vidéo customisé... Design, intégration et développement de tout le projet.
    `,
    img: img_project_arenafighttv,
    showcase: vid_project_arenafighttv,
    tags: ["React.js", "Redux.js", "Stripe.js", "E-commerce", "Firebase Auth", "Firebase Cloud", "Ant.design", "Rechart.js", "VideoPlayer"],
    date: ["Novembre 2020", "Décembre 2020"],
    link: "https://arenafighttv.com",
    github: ""
  },
  {
    id: uuid(),
    name: "Rent4aWeek | Luxurious cars",
    description: `
      Rent4aWeek est une plateforme ayant pour objectif de mettre en relation des propriétaires de voitures de luxes et des personnes cherchant à en louer une pour un temps court. La plateforme traitera les nouvelles voitures pour les classer par marques, qualité, préférences... Afin d'offrir une expérience unique et simple aux utilisateurs.
    `,
    img: img_project_rent4aWeek,
    showcase: vid_project_rent4aWeek,
    tags: ["React.js", "Google Firebase", "Web design", "UI / UX"],
    date: ["Avril 2020"],
    link: "https://rent4aweek.netlify.app/",
    github: "https://github.com/MaximeBF2000/Rent4aWeek"
  },
  {
    id: uuid(),
    name: "VideOzz | Netflix Like Show",
    description: `
      Développement design et frontend d'une platforme regroupant une grande quantité de films et séries. Le but de l'application est de fournir un maximum d'informations sur le film ou la série recherchée par l'utilisateur, ainsi que de donner une possibilité de visionner la vidéo en question, sur la plateforme ou par une redirection extérieure.
    `,
    showcase: "",
    img: img_project_videozz,
    showcase: vid_project_videozz,
    tags: ["React.js", "Web design", "Fast build"],
    date: ["Mars 2020"],
    link: "https://videozz.netlify.app/",
    github: "https://github.com/MaximeBF2000/Videozz"
  },
  {
    id: uuid(),
    name: "Maxime BOUNAAS-FERRET V3",
    description: `
      3ème version de mon site web de Développeur web Freelance. Site statique utilisant gatsby.js et react.js pour un site web performant et optimisé pour le SEO. Application serverless basée sur le JAMstack + réflexion de copywriting, A / B tests & mise en place de nombreux micro-services.
    `,
    img: img_project_moi_v3,
    tags: ["React.js", "Gatsby.js", "GraphQL", "JAMstack", "Copywriting", "SEO"],
    date: ["Février 2020", "Maintenant"],
    link: "https://maxime-bounaas.fr/",
    github: "https://github.com/MaximeBF2000/portfolio_v2_frontend"
  },
  {
    id: uuid(),
    name: "Livics - Spotify web player redesigned",
    description: `
      Clone de Spotify, utilisation de Material-UI pour un design simple, et utilisation de l'API de Spotify pour les données et le contrôle des musiques.
    `,
    img: img_livics,
    tags: ["React.js", "Spotify API", "Material-UI", ""],
    date: ["Septembre 2020"],
    link: "",
    github: ""
  },
  {
    id: uuid(),
    name: "Site vitrine | Antoine PAVY",
    description: `
      Site vitrine d'Antoine PAVY, commercial et développeur de stratégie marketing, composé d'une landing page et d'une about page.
    `,
    img: img_siteVitrineAntoinePavy,
    tags: ["SCSS", "Flexbox", "React-router"],
    date: ["Août 2020"],
    link: "https://antoine-pavy.netlify.app/",
    github: ""
  },
  {
    id: uuid(),
    name: "Foodtruck Online",
    description: `
      Participation au développement du site web de Foodtruck Online, un projet ayant pour objectif de mettre en relation des organisateurs d'événement et des foodtrucks. Scrum Team composé de 2 développeur front-end, 3 back-end, 1 designer et 2 exécutif marketing. (ps: le projet à été abandonné après 1 an)
    `,
    img: img_foodtruckOnline,
    tags: ["HTML5", "CSS3", "SASS", "Javascript", "SCRUM"],
    date: ["Septembre 2018", "Juillet 2019"],
    link: "https://www.facebook.com/Foodtruckonline-466504170419269/?ref=page_internal",
    github: ""
  },
  {
    id: uuid(),
    name: "Maxime BOUNAAS-FERRET V2",
    description: `
      2ème version de mon site web de Développeur web Freelance. Application serverless utilisant Netlify et Google Firebase avec une interface intégré avec React.js et React hooks.
    `,
    img: img_project_moi_v2,
    tags: ["React.js", "React hooks", "ContextAPI", "SASS"],
    link: "https://maxime-bounaas.netlify.app/",
    github: "https://github.com/MaximeBF2000/portfolio_v2_frontend"
  },
  {
    id: uuid(),
    name: "Where Am I",
    description: `
      Application permettant d'obtenir les coordonées GPS de n'importe quel endroit sur une map, ou de transformer une adresse en coordonnées GPS
    `,
    img: img_leafletMap,
    tags: ["Map application", "Leaflet API", "Javascript", "Algolia Places API"],
    link: "https://where-i-am.netlify.app/",
    github: "https://github.com/MaximeBF2000/Leaflet_GPS_coordinates_getter"
  },
  {
    id: uuid(),
    name: "3W-CODE",
    description: `
      Développement frontend et marketing du site de 3w-code, un projet de bootcamp en ligne de développement web.
    `,
    img: img_3wcode,
    tags: ["Frontend", "React.js", "SASS", "Marketing"],
    link: "https://3w-code.netlify.app/",
    github: ""
  },
  {
    id: uuid(),
    name: "Pareto's Constats",
    description: `
      Service permettant de faire des constats de rapport de productivité. L'application est basée sur la loi de Pareto, qui indique que 80% des résultats sont provoquées par 20% des entrées. L'application permet de créer, modifier ou supprimer des constats et de les visualisés sur des graphiques.
    `,
    img: img_paretoConstats,
    tags: ["Google Firebase", "ChartJS", "React.js", "Context API", "Saas"],
    link: "https://pareto-constats.netlify.app/",
    github: "https://github.com/MaximeBF2000/ParetoConstats__web"
  },
  {
    id: uuid(),
    name: "Maxime BOUNAAS-FERRET V1",
    description: `
      Première version du site vitrine de Maxime BOUNAAS-FERRET, freelance en développement web
    `,
    img: img_project_moi_v1,
    tags: ["HTML5", "CSS3", "SASS", "Vanilla JS", "Adobe XD"],
    link: "https://maxime-bounaasferret-v1.netlify.app/",
    github: "https://github.com/MaximeBF2000/portfolio_vanilla"
  },
  {
    id: uuid(),
    name: "Providus",
    description: `
      Réalisation d'une plateforme ecommerce pour apprendre à manipuler Redux.js et Typescript (PS: Plateforme non fonctionnelle)
    `,
    img: img_providus,
    tags: ["React.js", "ReduxJS", "Typescript", "SASS"],
    link: "https://providus.netlify.app/",
    github: "https://github.com/MaximeBF2000/Providus_Fake_EcommStore_redux_typescript"
  },
  {
    id: uuid(),
    name: "BOOKEY, The pocket librairy",
    description: `
      Application de recherche de livres, résumé, autheurs...
      Possibilité de noter les livres lus et suggestion de livre par intelligence artificiel.
    `,
    img: img_bookey,
    tags: ["React.js", "State Management", "SASS"],
    link: "https://bookey-librairy.netlify.app/",
    github: "https://github.com/MaximeBF2000/BOOKEY"
  },
  {
    id: uuid(),
    name: "DevJobLister",
    description: `
      Application de recherches de job pour les développeur (utilisation du MERNstack)
    `,
    img: img_devJobLister,
    tags: ["Javascript", "MERNstack", "React.js", "Node.js", "Mongodb"],
    link: "",
    github: "https://github.com/MaximeBF2000/devJobLister_MERN"
  },
  {
    id: uuid(),
    name: "AutowriteJS",
    description: `
      Librairie javascript open source permettant de créer un texte animé
    `,
    img: img_autowriteJs,
    tags: ["Javascript", "Open source", "VanillaJS"],
    link: "https://autowritejs.netlify.app",
    github: "https://github.com/MaximeBF2000/autoWriteJS"
  }
]

/* SKILLS __________________________________________________________________________________  */
export const skills = [
  {
    id: uuid(),
    name: "HTML5 / CSS3 / SCSS",
    color: "#2D7DD2",
    level: 95
  },
  {
    id: uuid(),
    name: "Javascript",
    color: "#f2df11",
    level: 95
  },
  {
    id: uuid(),
    name: "React.js",
    color: "#27DCFA",
    level: 90
  },
  {
    id: uuid(),
    name: "Gatsby.js / SEO",
    color: "#6e1bf5",
    level: 80
  },
  {
    id: uuid(),
    name: "Node.js",
    color: "#3e6e14",
    level: 70
  },
  {
    id: uuid(),
    name: "Mongodb",
    color: "#4DA14B",
    level: 85
  },
  {
    id: uuid(),
    name: "Google Firebase",
    color: "#FFA307",
    level: 95,
  },
  {
    id: uuid(),
    name: "Adobe XD",
    color: "#e835e2",
    level: 55,
  },
]

export const skills_tags = [
  "Git",
  "Responsive design",
  "Typescript",
  "React Hooks",
  "Context API",
  "Python",
  "SEO",
  "SEM",
  "Django",
  "Redux.js",
  "Photoshop",
  "Illustrator",
  "Premiere Pro",
  "Digital marketing"
]


/* PARCOURS ________________________________________________________________________________  */
export const parcours_step = [
  {
    date: "2019-2021",
    name: "Développeur Javascript / React.js Freelance",
    description: "Développement de nombreux projets en freelance & en continuant mon apprentissage de nouvelle technologies et méthodes de travail. En cours de création d'une entreprise de services digitaux."
  },
  {
    date: "2019-2021",
    name: "Formation en ligne en continu : Dévelopement web / logiciel & marketing digital",
    description: "Apprentissage en ligne du développement web fullstack en profondeur avec Javascript, React.js, Node.js et Mongodb. Développement de projets et auto apprentissage + expérience en entreprenariat dans le domaine du e-commerce."
  },
  {
    date: "2018-2019",
    name: "Développeur Frontend / Marketing - Foodtrucks Online",
    description: "Développeur frontend pour le site web / application foodtrucksOnline. Apprentissage de la gestion de projet en équipe, de la création et gestion d'un évènement, du préprocesseur CSS SASS, et d'outils de travails tel que git, github, trello..."
  },
  {
    date: "2018-2019",
    name: "Bachelor Informatique général - Ynov Lyon",
    description: "1ère année de bachelor informatique général à Ynov Lyon. Découverte du développement web, apprentissage de la méthode de travail SCRUM, de la gestion de projets et réalisations de 2 applications."
  }
]


/* FAQ _____________________________________________________________________________________  */
export const faq_content = [
  {
    question: "Pourquoi faire appel à un développeur ?",
    answer: "Avec le nombre d'outils disponibles actuellement pour créer facilement son site web, on peut se demander si il est vraiment utile de faire appel à un développeur. La réponse à cette question dépend de ce que vous souhaiter créer, voulez vous créer un site web à allure professionel, optimisée et adaptée à tout appareils ? Dans ce cas, il est préférable de passer par un professionel, qui pourra vous apportez ces possibilités en plus de ses conseils."
  },
  {
    question: "Combien ça coûte de créer un site web ?",
    answer: "Le prix d'un site web varie énormément et dépend des fonctionnalités que vous souhaitez apporter à celui-ci. C'est pourquoi je vous invite à me contacter afin que l'on discute de votre projet et que vous puissiez obtenir un devis TOTALEMENT GRATUIT et sans engagements de votre part."
  },
  {
    question: "Comment choisir le bon freelance pour vous aider dans vos projets ?",
    answer: "Trouver un indépendant capable de correctement remplir vos attentes peut parfois être compliqué et vous pourriez très rapidement vous rendre compte que ça ne matche pas. C'est pourquoi je vous conseille de contacter plusieurs indépendants, d'échanger sur votre projet et de prendre une décision après cela. Dans mon cas, je vous offre une période d'essai ainsi qu'une garanti satisfait ou remboursé."
  }
]